module.exports = __webpack_public_path__ + "static/media/cosplay6.564d4b87.jpg";